





















































import {Component, Vue, Watch} from 'vue-property-decorator';


@Component({})
export default class JdiMenu extends Vue {

    // only used for the mobile menu
    open = false;

    filter = '';

    items: { [key: string]: Array<[string, string] | '-'> } = {
        'Getting Started': [
            ['Installation', 'docs.start.installation'],
            ['Usage', 'docs.start.usage'],
            ['Changelog', 'docs.start.changelog'],
            ['Utilities', 'docs.start.utilities'],
        ],
        'Principles': [
            ['Dev Experience', 'docs.principles.dev-experience'],
            ['Future Adjustable', 'docs.principles.future-adjustable'],
            ['Tight Integration', 'docs.principles.tight-integration'],
        ],
        'Guidelines': [
            ['Animation', 'docs.guidelines.animation'],
            ['Color', 'docs.guidelines.color'],
            ['Glossary', 'docs.guidelines.glossary'],
            ['Grammar', 'docs.guidelines.grammar'],
            ['Icons', 'docs.guidelines.icons'],
            ['Spacing', 'docs.guidelines.spacing'],
        ],
        'Foundation': [
            ['Loaders', 'docs.foundation.loaders'],
            ['Locale Provider', 'docs.foundation.locale-provider'],
            ['Text Provider', 'docs.foundation.text-provider'],
        ],
        'Components': [
            ['Article', 'docs.components.article'],
            ['Button', 'docs.components.button'],
            ['Callout', 'docs.components.callout'],
            ['Datum', 'docs.components.datum'],
            ['Echo', 'docs.components.echo'],
            ['Link', 'docs.components.link'],
            ['Money', 'docs.components.money'],
            ['Paginator', 'docs.components.paginator'],
            ['Reaction Panel', 'docs.components.reaction-panel'],
            ['Terminology', 'docs.components.terminology'],
            ['Timeline', 'docs.components.timeline'],
            ['Timestamp', 'docs.components.timestamp'],
        ],
        'Patterns': [
            ['Action Box', 'docs.patterns.action-box'],
            ['Breakdown', 'docs.patterns.breakdown'],
            ['Confirmation', 'docs.patterns.confirmation'],
            ['Dialog', 'docs.patterns.dialog'],
            ['Drafting Table', 'docs.patterns.drafting-table'],
            ['Dropdown Menu', 'docs.patterns.dropdown-menu'],
            ['Explorer', 'docs.patterns.explorer'],
            ['Inspector', 'docs.patterns.inspector'],
            ['Meridian', 'docs.patterns.meridian'],
            ['Navigator', 'docs.patterns.navigator'],
            ['Page', 'docs.patterns.page'],
            ['Pipeline', 'docs.patterns.pipeline'],
            ['Sheet', 'docs.patterns.sheet'],
            ['Spotlight', 'docs.patterns.spotlight'],
            ['Table', 'docs.patterns.table'],
            ['Toolbar', 'docs.patterns.toolbar'],
            ['Workbench', 'docs.patterns.workbench'],
        ],
        'Forms': [
            ['Overview', 'docs.forms.overview'],
            ['Layout', 'docs.forms.layout'],
            ['Validation', 'docs.forms.validation'],
            '-',
            ['Checkbox', 'docs.forms.checkbox'],
            ['Color Picker', 'docs.forms.color-picker'],
            ['Select Field', 'docs.forms.select-field'],
            ['Text Field', 'docs.forms.text-field'],
        ],
        'Constructs': [
            ['Attribute Sticker', 'docs.constructs.attribute-sticker'],
            ['Candidate Bubble', 'docs.constructs.candidate-bubble'],
            ['Job Tile', 'docs.constructs.job-tile'],
            ['Nametag', 'docs.constructs.nametag'],
            ['Score Badge', 'docs.constructs.score-badge'],
        ],
        'Helpers': [
            ['Structural button', 'docs.helpers.structural-button']
        ]
    };

    get filteredItems() {
        if (!this.filter) return this.items;
        return Object.keys(this.items)
            .map(section => [section, this.items[section].filter(([name, route]) =>
                name.toLocaleLowerCase().includes(this.filter.toLocaleLowerCase()))])
            .reduce((prev, [section, items]) => Object.assign(prev, {[section as string]: items}), {});
    }

    mounted() {
        window.addEventListener('keydown', this.filterHotkeyListener);
    }

    beforeDestroy() {
        window.removeEventListener('keydown', this.filterHotkeyListener);
    }

    @Watch('$route')
    closeOnNavigation() {
        this.open = false;
    }

    filterHotkeyListener(event: KeyboardEvent) {
        if (event.key === '/' && !['INPUT', 'TEXTAREA'].includes((event.target as HTMLHtmlElement).tagName)) {
            (this.$refs['filter'] as HTMLInputElement)?.focus();
            event.preventDefault();
        }
    }

}
